export default "__VITE_ASSET__D6evo6Tf__"